import { SortableContext, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useEffect, useMemo, useState } from "react";
import { Separator } from "@components/common/separator";
import { DictType } from "@pma/types";
import UsersTaskCard from "./users-task-card";

interface Props {
  column: any;
  deleteColumn: (id: any) => void;
  updateColumn: (id: any, title: string) => void;
  createTask: (columnId: any) => void;
  updateTask: (id: any, content: string) => void;
  deleteTask: (id: any) => void;
  tasks: any[];
}

function ColumnContainer({
  column,
  deleteColumn,
  updateColumn,
  createTask,
  tasks,
  deleteTask,
  updateTask,
}: Props) {
  const [editMode, setEditMode] = useState(false);

  const tasksIds = useMemo(() => {
    return tasks?.map((task) =>task?.uqId);
  }, [tasks]);
  

  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
    active,
    activeIndex
  } = useSortable({
    id: column.id,
    data: {
      type: "Column",
      column,
    },
    disabled: editMode,
  });

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
  };

  if (isDragging) {
    return (
      <div
        ref={setNodeRef}
        style={style}
        className="flex h-[500px] max-h-[500px] w-[350px] flex-col rounded-md border-2 border-secondary/60 bg-primary/50 opacity-40"
      ></div>
    );
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex max-h-[700px] min-h-[500px] w-[350px] flex-col rounded-md bg-primary/10"
    >
      {/* Column title */}
      <div
        {...attributes}
        {...listeners}
        onClick={() => {
          setEditMode(true);
        }}
        className="text-md flex  cursor-grab items-center justify-between rounded-md rounded-b-none border-1 border-primary  bg-slate-200 p-3 font-bold"
      >
        <div className="w-full flex items-center flex-col gap-2 text-center">
          <div className="h-20 w-20 rounded-full">
            <img
              src={
                column?.picture || `${process.env.PUBLIC_URL}/user-profile.svg`
              }
              className="h-full w-full rounded-full"
              alt={column?.title}
            />
          </div>
          <div className="inline item-center justify-center">
            <span>{column?.title}</span>

            <span className="text-slate-500 text-sm pl-1">
              ({column?.count})
            </span>
          </div>
        </div>
      </div>
      <Separator />

      <div className="flex flex-grow flex-col gap-4 overflow-y-auto overflow-x-hidden p-2">
        <SortableContext items={tasksIds}>
          {column?.tasks?.map((task: DictType) => (
            <UsersTaskCard
              key={task.id}
              task={task}
              deleteTask={deleteTask}
              updateTask={updateTask}
            />
          ))}
        </SortableContext>
      </div>
      {/* Column footer */}
      {/* <button
        className="border-columnBackgroundColor border-x-columnBackgroundColor hover:bg-mainBackgroundColor flex items-center gap-2 rounded-md border-2 p-4 hover:text-rose-500 active:bg-black"
        onClick={() => {
          createTask(column.id);
        }}
      >
        <PlusIcon />
        Add task
      </button> */}
    </div>
  );
}

export default ColumnContainer;
